import * as React from 'react';
import { connect } from 'react-redux';
import { setSSPData, getAsLocalCurrency, redirectToUrl } from '../../../actions/sspActions';
import { validatePayment } from '../../../actions/paymentActions';
import { navigateTo } from '../../../actions/navigationActions';
import { DASHBOARD, PAYMENT_FAILURE } from '../../../routes/routes';
import '../../BaseTemplate/SSPCustomComponentLibrary/KPSelectableList/KPSelectableList.css'
import './Payment.css';

//@ts-ignore
import animationData from '../../LoadingScreens/Amendments-loader-ani01-A.json';
import Lottie from 'react-lottie';

class PaymentInitialize extends React.Component<any, any> {
    methodCard = "Card";
    methodEFT = "EFT";

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            reference: "",
            amount: 0.0,
            valid: false,
            redirectUrl_Card: "",
            redirectUrl_EFT: "",
            paymentEnabled: false,
            paymentMethod: "",
            paymentMethodUrl: "",
            systemError: false,
            useFrame: false,
        };

        this.loadTransaction = this.loadTransaction.bind(this);
        this.handleSetMethod = this.handleSetMethod.bind(this);
        this.handleContinuePayment = this.handleContinuePayment.bind(this);
        this.handleCancelPayment = this.handleCancelPayment.bind(this);

        this.handleMessageReceived = this.handleMessageReceived.bind(this);
        window.addEventListener("message", this.handleMessageReceived, false);
    }

    componentDidMount() {
        this.loadTransaction();
    }

    async loadTransaction() {
        this.setState({ loading: true }, async () => { 
            let reference = this.props.match.params.reference;
            let response = await this.props.dispatchAction(validatePayment(reference));

            this.setState({
                loading: false,
                reference,
                amount: this.props.dispatchAction(getAsLocalCurrency(Number(response.amount))),
                valid: response.valid,
                redirectUrl_Card: response.redirectUrl_Card,
                redirectUrl_EFT: response.redirectUrl_EFT,
                systemError: response.systemError,
            });
        });
    }

    handleSetMethod(method: any) {
        let methodUrl = this.state["redirectUrl_" + method];
        let enabled = methodUrl.length > 0;

        this.setState({
            paymentEnabled: enabled,
            paymentMethod: method,
            paymentMethodUrl: methodUrl,
        });
    }

    handleContinuePayment(e: any) {
        if (!this.state.paymentEnabled) {
            e.preventDefault();
        }
        else if (this.state.paymentMethod === this.methodCard) {
            e.preventDefault();
            this.setState({ loading: true, useFrame: true });
        }
        else if (this.state.paymentMethod === this.methodEFT) {
            e.preventDefault();
            this.props.dispatchAction(redirectToUrl(this.state.paymentMethodUrl));
        }
    }

    handleCancelPayment() {
        if (this.props.ssp.paymentPortalOnly) {
            this.props.dispatchAction(redirectToUrl(this.props.ssp.portalRedirectUrl));
        } else {
            this.props.dispatchAction(navigateTo(DASHBOARD));
        }
    }

    handleMessageReceived(e: any) {
        if (e.origin?.toLowerCase().includes("payat.io")) {
            if (e.data === "onLoad") {
                this.setState({ loading: false });
            }
            if (e.data === "onClose" && this.state.paymentMethod === this.methodCard) {
                let url = PAYMENT_FAILURE.replace(":reference", this.state.reference);
                this.props.dispatchAction(navigateTo(url));
            }
        }
    }

    public render() {
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            },
        };

        return (
            <div id="PaymentContainer" className="pt-lg-5 p-lg-0 logged-out">
                {/*Loading indicator*/}
                {this.state.loading &&
                    <div className="notice-container red">
                        <div className="notice-container-content row">
                            <div className="col-md-6 offset-md-3 text-center">
                                <div>
                                    <Lottie className="ChatLottie" options={defaultOptions}
                                        height="100px"
                                        width="100px"
                                        isStopped={false}
                                        isPaused={false}
                                    />
                                </div>
                                <div className="notice-text mt-4">
                                    Please be patient while we get your payment details
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {/*Transaction/payment no longer valid*/}
                {!this.state.loading && !this.state.valid &&
                    <div className="notice-container red">
                        <div className="notice-container-content row">
                            <div className="col-md-6 offset-md-3 text-center">
                                <div>
                                    <img src="./images/payment/payment-failed-icon.svg" alt="Failed" />
                                </div>
                                <div className="notice-text mt-4">
                                    Payment link no longer valid
                                </div>
                                <div>
                                    <button onClick={this.handleCancelPayment} className="btn btn-outline-white btn-responsive btn-lg">Okay</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {/*Payment method selector*/}
                {!this.state.loading && this.state.valid && !this.state.useFrame &&
                    <div className="container">
                        <div className="payment-card col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                            <div id="btnBack" onClick={this.handleCancelPayment}>
                                <img src="./images/icons-navigation-back-grey.svg" alt="<" className="mr-2" />
                                <span>Back</span>
                            </div>

                            <div className="payment-card-title mt-4 mb-4">
                                Choose your payment method
                            </div>

                            <div className="payment-card-subtitle">
                                Total amount payable
                            </div>

                            <div className="payment-card-amount">
                                {this.state.amount}
                            </div>

                            {this.state.valid &&
                                <div className="mt-4">
                                    {(this.state.redirectUrl_Card?.length > 0) &&
                                        <div className="mt-4">
                                            <div className={"row payment-type-selector" + ((this.state.paymentMethod === this.methodCard) ? " selected" : "")} onClick={()=>this.handleSetMethod(this.methodCard)}>
                                                <div className="col-1 nopa input-container">
                                                    <div className={"cursor-pointer ssp-selectable-list-item-selector radioGroup left-align" + ((this.state.paymentMethod === this.methodCard) ? " selected" : "")}>
                                                    </div>
                                                </div>
                                                <div className="col-10 col-md-8 ssp-selectable-list-item-description">
                                                    <div className="payment-type-title">
                                                        Debit/credit card
                                                    </div>
                                                    <div className="payment-type-description">
                                                        Please supply your debit or credit card account details.
                                                    </div>
                                                </div>
                                                <div className="col-md-3 nopa">
                                                    <div className="img-container">
                                                        <img src="./Images/payment/payment-method-visa.svg" alt="Visa" title="Visa" />
                                                        <img src="./Images/payment/payment-method-mastercard.svg" alt="Mastercard" title="Mastercard" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    {(this.state.redirectUrl_EFT?.length > 0) &&
                                        <div className="mt-4">
                                            <div className={"row payment-type-selector" + ((this.state.paymentMethod === this.methodEFT) ? " selected" : "")} onClick={() => this.handleSetMethod(this.methodEFT)}>
                                                <div className="col-1 nopa input-container">
                                                    <div className={"cursor-pointer ssp-selectable-list-item-selector radioGroup left-align" + ((this.state.paymentMethod === this.methodEFT) ? " selected" : "")}>
                                                    </div>
                                                </div>
                                                <div className="col-10 col-md-8 ssp-selectable-list-item-description">
                                                    <div className="payment-type-title">
                                                        instantEFT
                                                    </div>
                                                    <div className="payment-type-description">
                                                        Please follow the EFT payment instructions.
                                                    </div>
                                                </div>
                                                <div className="col-md-3 nopa">
                                                    <div className="img-container">
                                                        <img src="./Images/payment/payment-method-eft-payfast.png" alt="Payfast-EFT" title="Payfast-EFT" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }

                            <div className="content-devider"></div>

                            <div className="mt-4">
                                <button onClick={this.handleContinuePayment} className={"btn btn-solid-green btn-responsive btn-lg" + (!this.state.paymentEnabled ? " disabled" : "")}>Pay now</button>
                            </div>

                            <div className="mt-4">
                                <button onClick={this.handleCancelPayment} className="btn btn-outline-red btn-responsive btn-lg">Cancel</button>
                            </div>

                            <div className="footer-notice mt-4">
                                <img src="./images/payment/secure-connection-icon.svg" alt="Secured" className="img-secure-icon mr-3" />
                                <div>
                                    <b>Secure connection:</b> Your info’s encrypted, which means it’s totally safe with us
                                </div>
                            </div>

                        </div>
                    </div>
                }

                {/*iFrame for Card Payment method*/}
                {this.state.paymentEnabled && this.state.useFrame &&
                    <div className="payment-frame">
                        <iframe
                            src={this.state.paymentMethodUrl}
                            frameBorder="0"
                            height="100%"
                            width="100%"
                            scrolling="no"
                        />
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        ssp: state.ssp,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentInitialize);